import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { GradeGroupsTable } from '../../../components/GradeGroups/GradeGroupsTable';
import { Page } from '../../../components/Page/Page';
import { usePermissionChecker } from '../../../hooks/usePermissionChecker';

export const GradeGroups: FC = () => {
  const { t } = useTranslation();
  const permissions = usePermissionChecker();

  return (
    <Page isForbidden={!permissions?.canManageSettings()} title={t('gradeGroups.title', { count: 2 })}>
      <GradeGroupsTable />
    </Page>
  );
};
